export const DEFAULT_ERROR_MESSAGE = "*We could not complete your action, please contact your Health System.";
